import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h4 mb-3" }, "Personal Information")
], -1)
const _hoisted_2 = { class: "container animated fadeIn" }
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 col-mb-2 col-sm-12 col-12" }, null, -1)
const _hoisted_5 = { class: "col-lg-8 col-md-8 col-sm-10 col-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "form-group text-left" }
const _hoisted_9 = /*#__PURE__*/_createVNode("small", null, "Email", -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_12 = { class: "form-group text-left" }
const _hoisted_13 = /*#__PURE__*/_createVNode("small", null, "First Name", -1)
const _hoisted_14 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_15 = { class: "form-group text-left" }
const _hoisted_16 = /*#__PURE__*/_createVNode("small", null, "Last Name", -1)
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-6 col-md-6 col-sm-12 mb-3 text-left" }
const _hoisted_19 = /*#__PURE__*/_createVNode("small", null, "Birthdate*", -1)
const _hoisted_20 = { class: "form-group text-left" }
const _hoisted_21 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_22 = { class: "col-lg-6 col-md-6 col-sm-12 text-left" }
const _hoisted_23 = /*#__PURE__*/_createVNode("small", null, "Occupation", -1)
const _hoisted_24 = { class: "form-group text-left" }
const _hoisted_25 = {
  key: 0,
  class: "row"
}
const _hoisted_26 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_27 = { class: "form-group text-left" }
const _hoisted_28 = /*#__PURE__*/_createVNode("small", null, "Phone Number", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("small", null, " Link your mobile phone. This will help you secure your account. ", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("small", { class: "text-danger" }, null, -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_33 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_36 = { class: "form-group text-left" }
const _hoisted_37 = /*#__PURE__*/_createVNode("small", null, "Street*", -1)
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_40 = { class: "form-group text-left" }
const _hoisted_41 = /*#__PURE__*/_createVNode("small", null, "Street Number*", -1)
const _hoisted_42 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_43 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_44 = { class: "form-group text-left" }
const _hoisted_45 = /*#__PURE__*/_createVNode("small", null, "Apt/Unit/Suite Number", -1)
const _hoisted_46 = { class: "text-danger" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_49 = { class: "form-group text-left" }
const _hoisted_50 = /*#__PURE__*/_createVNode("small", null, "City*", -1)
const _hoisted_51 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_52 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_53 = { class: "form-group text-left" }
const _hoisted_54 = /*#__PURE__*/_createVNode("small", null, "Province*", -1)
const _hoisted_55 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_58 = { class: "form-group text-left" }
const _hoisted_59 = /*#__PURE__*/_createVNode("small", null, "Postal Code*", -1)
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-lg-12 col-md-12 col-sm-12" }
const _hoisted_62 = { class: "form-group text-left" }
const _hoisted_63 = /*#__PURE__*/_createVNode("small", null, "Address Line 2", -1)
const _hoisted_64 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_65 = { class: "row justify-content-left" }
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = /*#__PURE__*/_createVNode("label", null, " Are you involved, related, or closely associated with any members of government? ", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_69 = { class: "form-check form-check-inline" }
const _hoisted_70 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label mr-3",
  for: "yesOption"
}, " Yes ", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "noOption"
}, "No", -1)
const _hoisted_72 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_73 = { class: "row mt-4 mb-5" }
const _hoisted_74 = { class: "col d-flex justify-content-around" }
const _hoisted_75 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sat-street"
}, [
  /*#__PURE__*/_createVNode("svg", {
    style: {"width":"1rem","height":"1rem"},
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      fill: "currentColor",
      d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Previous ")
], -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_77 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"1rem","height":"1rem"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
  })
], -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 col-mb-2 col-sm-12 col-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")
  const _component_place_autocomplete_field = _resolveComponent("place-autocomplete-field")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("form", null, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userProfile.email = $event)),
                    "aria-describedby": "emailHelp",
                    placeholder: "Enter email",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userProfile.email]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "firstName",
                    name: "firstName",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.userProfile.firstName = $event)),
                    placeholder: "First Name",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userProfile.firstName]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "lastName",
                    name: "lastName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.userProfile.lastName = $event)),
                    placeholder: "Last Name",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.userProfile.lastName]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  _withDirectives(_createVNode("input", {
                    class: "form-control",
                    type: "date",
                    name: "birthdate",
                    id: "birthdate",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.stepOneForm.props.birthdate = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.birthdate]
                  ])
                ]),
                (_ctx.stepOneForm.controls.birthdate.dirty)
                  ? (_openBlock(), _createBlock("small", _hoisted_21, _toDisplayString(_ctx.stepOneForm.controls.birthdate.errorMessage), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "occupation",
                    name: "occupation",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.stepOneForm.props.occupation = $event)),
                    placeholder: "Occupation"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.occupation]
                  ]),
                  (_ctx.stepOneForm.controls.occupation.dirty)
                    ? (_openBlock(), _createBlock("small", {
                        key: 0,
                        class: "text-danger",
                        textContent: _toDisplayString(_ctx.stepOneForm.controls.occupation.errorMessage)
                      }, null, 8, ["textContent"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_vue_tel_input, {
                        defaultCountry: 
                    _ctx.stepOneForm.props.phoneCountry?.toLowerCase() || 'ca'
                  ,
                        value: _ctx.stepOneForm.props.phoneNumber,
                        onInput: _ctx.changePhone,
                        onCountryChanged: _ctx.changeCountryInputTel
                      }, null, 8, ["defaultCountry", "value", "onInput", "onCountryChanged"]),
                      _hoisted_29,
                      _hoisted_30
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                (_ctx.isResultAddress)
                  ? _withDirectives((_openBlock(), _createBlock("textarea", {
                      key: 0,
                      class: "form-control mb-3",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.autocomplete = $event)),
                      rows: "2",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetAutocomplete && _ctx.resetAutocomplete(...args)))
                    }, null, 512)), [
                      [_vModelText, _ctx.autocomplete]
                    ])
                  : (_openBlock(), _createBlock(_component_place_autocomplete_field, {
                      key: 1,
                      onAutocompleteSelect: _ctx.selectAddress,
                      modelValue: _ctx.autocomplete,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.autocomplete = $event)),
                      "component-restrictions": { country: ['CA'] },
                      libraries: ['places', '&language=EN&region=CA'],
                      name: "autocomplete",
                      "api-key": _ctx.apiKeyGoogle,
                      placeholder: "Enter an address, zipcode, or location to autofill*"
                    }, null, 8, ["onAutocompleteSelect", "modelValue", "api-key"]))
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "street",
                    name: "street",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.stepOneForm.props.street = $event)),
                    placeholder: "Street*"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.street]
                  ]),
                  (_ctx.stepOneForm.controls.street.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_38, _toDisplayString(_ctx.stepOneForm.controls.street.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "streetNumber",
                    name: "streetNumber",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.stepOneForm.props.streetNumber = $event)),
                    placeholder: "Street Number*"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.streetNumber]
                  ]),
                  (_ctx.stepOneForm.controls.streetNumber.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_42, _toDisplayString(_ctx.stepOneForm.controls.streetNumber.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_43, [
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "interiorNumber",
                    name: "interiorNumber",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.stepOneForm.props.interiorNumber = $event)),
                    placeholder: "Apt/Unit/Suite Number"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.interiorNumber]
                  ]),
                  _createVNode("small", _hoisted_46, _toDisplayString(_ctx.stepOneForm.controls.interiorNumber.errorMessage), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "city",
                    name: "city",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.stepOneForm.props.city = $event)),
                    placeholder: "City*"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.city]
                  ]),
                  (_ctx.stepOneForm.controls.city.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_51, _toDisplayString(_ctx.stepOneForm.controls.city.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "province",
                    name: "province",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.stepOneForm.props.province = $event)),
                    placeholder: "Province*"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.province]
                  ]),
                  (_ctx.stepOneForm.controls.province.dirty)
                    ? (_openBlock(), _createBlock("small", _hoisted_55, _toDisplayString(_ctx.stepOneForm.controls.province.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode("div", _hoisted_57, [
                _createVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "postalCode",
                    name: "postalCode",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.stepOneForm.props.postalCode = $event)),
                    placeholder: "Postal Code*"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.postalCode]
                  ]),
                  (_ctx.stepOneForm.controls.postalCode.dirty)
                    ? (_openBlock(), _createBlock("small", {
                        key: 0,
                        class: "text-danger",
                        textContent: _toDisplayString(_ctx.stepOneForm.controls.postalCode.errorMessage)
                      }, null, 8, ["textContent"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    id: "addressLine2",
                    name: "addressLine2",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.stepOneForm.props.addressLine2 = $event)),
                    placeholder: "Address Line 2",
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, _ctx.stepOneForm.props.addressLine2]
                  ]),
                  (_ctx.stepOneForm.controls.addressLine2.errorMessage)
                    ? (_openBlock(), _createBlock("small", _hoisted_64, _toDisplayString(_ctx.stepOneForm.controls.addressLine2.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _createVNode("div", _hoisted_66, [
                _hoisted_67,
                _hoisted_68,
                _createVNode("div", _hoisted_69, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "inlineRadioOptions",
                    id: "yesOption",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.stepOneForm.props.government = $event)),
                    value: true
                  }, null, 512), [
                    [_vModelRadio, _ctx.stepOneForm.props.government]
                  ]),
                  _hoisted_70,
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "inlineRadioOptions",
                    id: "noOption",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.stepOneForm.props.government = $event)),
                    value: false
                  }, null, 512), [
                    [_vModelRadio, _ctx.stepOneForm.props.government]
                  ]),
                  _hoisted_71
                ]),
                (_ctx.stepOneForm.controls.government.dirty)
                  ? (_openBlock(), _createBlock("small", _hoisted_72, _toDisplayString(_ctx.stepOneForm.controls.government.errorMessage), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_73, [
              _createVNode("div", _hoisted_74, [
                _createVNode(_component_router_link, { to: { name: 'verify.zero' } }, {
                  default: _withCtx(() => [
                    _hoisted_75
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode("button", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submit())),
                  type: "button",
                  class: "btn btn-sat-street"
                }, [
                  _hoisted_76,
                  _hoisted_77
                ])
              ])
            ])
          ])
        ]),
        _hoisted_78
      ])
    ])
  ], 64))
}